import {createElement, PropTypes} from 'rlink-react';

export default function ShopItemTitle ({css, wrap, title, subtitle}) {
  let titleText = `${title}${(subtitle) ? ':' : ''}`;
  if (wrap) {
    return (
      <div className={css['modal-header']}>
        <div className={css.title}>{titleText}</div>
        {(subtitle) ? <div className={css.subtitle}>{` ${subtitle}`}</div> : []}
      </div>
    );
  }

  return (<span className={css.title}>{`${titleText}${(subtitle) ? ` ${subtitle}` : ''}`}</span>);
}

ShopItemTitle.propTypes = {
  css: PropTypes.object,
  wrap: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ShopItemTitle.defaultProps = {
  wrap: false,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopItemTitle.jsx